<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">Anasayfa</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active">Anasayfa</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <!--<search-customer></search-customer>-->
          <div
            class="col-md-8"
            v-if="
              auth.AppWatch != null && auth.AppWatch.isWrite
            "
          >
            <watch-list></watch-list>
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</template>
<script>

//import SearchCustomer from './SearchCustomer'
import WatchList from './WatchList.vue'
export default {
  data() {
    return {
      auth: this.$store.getters.getModules,
    }
  },
  components: {
    //SearchCustomer,
    WatchList
  },
  methods: {

  },
  watch: {
    "$store.getters.getModules"() {
      this.auth = this.$store.getters.getModules;
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Main.vue